import React from 'react';
import * as PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import FormField from './FormField';
import PhoneInput, {
    type ICountry,
} from 'react-native-international-phone-number';

const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
});

interface Props {
    placeholder?: string;
    value?: string;
    setFieldValue: any;
    setFieldTouched: any;
    style?: object;
}

const TelInput: React.FC<Props> = ({
    placeholder,
    value = '',
    setFieldValue,
    setFieldTouched,
    style,
}) => {
    const [selectedCountry, setSelectedCountry] = React.useState<
        ICountry | undefined
    >(undefined);

    const adjustPhoneNumber = (data: string): void => {
        const adjustedPhoneNumber = selectedCountry?.callingCode + ' ' + data;
        if (data !== null && data !== '') setFieldValue(adjustedPhoneNumber);
        else setFieldValue('');
    };

    return (
        <View style={style}>
            <PhoneInput
                value={
                    value === 'undefined'
                        ? ''
                        : value?.replace(selectedCountry?.callingCode, '')
                }
                defaultCountry="JP"
                onChangePhoneNumber={adjustPhoneNumber}
                selectedCountry={selectedCountry}
                onChangeSelectedCountry={(country: ICountry) => {
                    setSelectedCountry(country);
                    setFieldValue('');
                }}
                placeholder={placeholder}
                phoneInputStyles={style.phoneArea}
            />
        </View>
    );
};

TelInput.defaultProps = {
    placeholder: '',
    value: '',
    style: styles.container,
};

TelInput.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string,
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired,
};

export default FormField(TelInput);
